import { makeStyles } from 'tss-react/mui';

const useOnStarContentBannerStyles = makeStyles()(() => ({
  root: {
    backgroundColor: '#0956FF',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    minHeight: '40px',
    padding: '12px 16px',
    width: '100%',
  },
}));

export default useOnStarContentBannerStyles;
